import { 
    TOGGLE_SIDE_NAV,
    ISSUES_PROCESSING,
    ISSUES_PROCESSING_DONE
} from '../actions/types';

const initialState = {
    sideNav: false, // State of the side navigation
    issue_processing: false // Report an issue page state
}

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case TOGGLE_SIDE_NAV: 

            // Toggle the sideNav state between open and closed
            return {
                ...state,
                sideNav: !state.sideNav
            }
        case ISSUES_PROCESSING:
        
            return {
                ...state,
                issue_processing: true,
            }
        case ISSUES_PROCESSING_DONE:

            return {
                ...state,
                issue_processing: false,
            }

        default:
            return state;
    }
}